async function req(method, path, body) {
    const res = await fetch(path, {
        method,
        credentials: "same-origin",
        headers: body ? { "content-type": "application/json" } : undefined,
        body: body ? JSON.stringify(body) : undefined,
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(json.error ?? `http_${res.status}`);
        err.status = res.status;
        err.payload = json;
        throw err;
    }
    return json;
}
export const api = {
    get: (p) => req("GET", p),
    post: (p, body) => req("POST", p, body),
    patch: (p, body) => req("PATCH", p, body),
    put: (p, body) => req("PUT", p, body),
    del: (p) => req("DELETE", p),
};
/**
 * Grade letter for a total against an exam's max marks.
 * Percentage bands: A ≥ 75, B ≥ 65, C ≥ 50, S ≥ 35, F below.
 * Returns null if max is 0 or total isn't a number/AB.
 */
export function gradeFor(total, maxMarks) {
    if (total === "AB")
        return "AB";
    if (typeof total !== "number")
        return null;
    if (!maxMarks || maxMarks <= 0)
        return null;
    const pct = (total / maxMarks) * 100;
    if (pct >= 75)
        return "A";
    if (pct >= 65)
        return "B";
    if (pct >= 50)
        return "C";
    if (pct >= 35)
        return "S";
    return "F";
}
